import { render, staticRenderFns } from "./FileAttachmentComponent.vue?vue&type=template&id=41a7a39d&scoped=true&"
import script from "./FileAttachmentComponent.vue?vue&type=script&lang=js&"
export * from "./FileAttachmentComponent.vue?vue&type=script&lang=js&"
import style0 from "./FileAttachmentComponent.vue?vue&type=style&index=0&id=41a7a39d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a7a39d",
  null
  
)

export default component.exports